import { mix, useCanvasLoop } from "@/components/canvasLoop";

const DARK = { bg: "#1E1A17", line: [247, 244, 239], accent: [212, 163, 115] };

const drawFrame = (ctx, w, h, t) => {
  ctx.fillStyle = DARK.bg;
  ctx.fillRect(0, 0, w, h);
  const rows = w < 640 ? 26 : 38;
  const top = h * 0.14;
  const gap = (h * 0.8) / rows;
  const cx = w < 640 ? w * 0.5 : w * 0.66;
  const spread = w < 640 ? w * 0.32 : w * 0.2;
  for (let i = 0; i < rows; i++) {
    const y0 = top + i * gap;
    const swell = Math.pow(Math.max(0, Math.sin(t * 0.45 - i * 0.22)), 3);
    const amp = gap * (1.2 + swell * 7);
    ctx.beginPath();
    ctx.moveTo(0, y0);
    for (let x = 0; x <= w; x += 5) {
      const d = (x - cx) / spread;
      const env = Math.exp(-d * d);
      const n = Math.sin(x * 0.021 + t * 1.3 + i * 1.7) * 0.5 + Math.sin(x * 0.047 - t * 0.9 + i * 0.6) * 0.35 + Math.sin(x * 0.11 + t * 2.1 + i) * 0.15;
      ctx.lineTo(x, y0 - amp * env * Math.abs(n));
    }
    ctx.lineTo(w, y0 + gap * 2);
    ctx.lineTo(0, y0 + gap * 2);
    ctx.closePath();
    ctx.fillStyle = DARK.bg;
    ctx.fill();
    const [r, g, b] = mix(DARK.line, DARK.accent, swell);
    ctx.strokeStyle = `rgba(${r},${g},${b},${0.22 + swell * 0.55})`;
    ctx.lineWidth = 1;
    ctx.stroke();
  }
};

export const BaselineCanvas = () => {
  const ref = useCanvasLoop(drawFrame);
  return <canvas ref={ref} className="absolute inset-0 w-full h-full" aria-hidden="true" data-testid="hero-baseline-canvas" />;
};
